import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Hiring } from '../classes/hiring';
import { ApiService } from './api/api.service';
import { EntityTypeCode } from './entities/entity-type.class';
import { RealtimeType } from './realtime/realtime-type.enum';
import { RealtimeService } from './realtime/realtime.service';
import { WebsocketService } from './websocket/websocket.service';

@Injectable({
    providedIn: 'root',
})
export class HiringService extends RealtimeService<Hiring> {
    constructor(
        protected apiService: ApiService,
        protected websocketService: WebsocketService
    ) {
        super(websocketService, RealtimeType.hiring);
    }

    getList(beginDate?: Date, endDate?: Date): Observable<Hiring[]> {
        return super.getList().pipe(map(a => a.sort((a, b) => a.order - b.order)));
    }

    getAll(): Observable<Hiring[]> {
        return this.apiService
            .getCallData$<Hiring[]>(`${this.type}/all`)
            .pipe(map(hiring => hiring.sort((a, b) => a.order - b.order)));
    }

    getByType(code: EntityTypeCode | string): Observable<Hiring[]> {
        return this.getList().pipe(
            map(hire => hire.filter(hiring => hiring.entitytypes.map(e => e.key).includes(String(code))))
        );
    }

    itemInDaterange(hiring: Hiring, fromDate: Date, toDate: Date) {
        throw new Error('Method not implemented.');
    }

    save(entity: Hiring): Promise<Hiring> {
        return this.apiService.postCall(this.type, entity);
    }

    get(id: number): Promise<Hiring> {
        return this.apiService.getCall(`${this.type}/${id}`);
    }
}
